import React from "react";
import { useLocation } from "react-router-dom";
import "./App.css";
import Router from "./Router";
import { BrowserRouter } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material";
import TopBar from "../src/app/components/TopBar";
import BackToTop from "react-back-to-top";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { BottomBar } from "./app/components";
import ScrollToTop from "./app/components/RouteToTop";

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#22d3ee", dark: "#06b6d4", light: "#67e8f9" },
    secondary: { main: "#3b82f6", dark: "#2563eb" },
    background: { default: "#070b14", paper: "#0f172a" },
    text: { primary: "#f8fafc", secondary: "#94a3b8" },
    divider: "rgba(56, 189, 248, 0.15)",
  },
  typography: {
    fontFamily: "Montserrat, sans-serif",
  },
  shape: { borderRadius: 10 },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
      },
    },
  },
});

const LANDING_PREFIXES = ["/", "/about", "/contact", "/book", "/services", "/terms", "/transaction"];

function isLandingRoute(pathname) {
  if (pathname === "/") return true;
  return LANDING_PREFIXES.some((p) => p !== "/" && pathname.startsWith(p));
}

function AppChrome({ children }) {
  const location = useLocation();
  const landing = isLandingRoute(location.pathname);

  return (
    <div className={`App${landing ? " chz-landing-app" : ""}`}>
      {!landing && <TopBar />}
      {children}
      <ScrollToTop />
      {!landing && (
        <>
          <BackToTop
            mainStyle={{
              "border-radius": 30,
              "background-color": "var(--primaryColor) !important",
            }}
            children={<KeyboardArrowUpIcon sx={{ color: "var(--appBg) !important" }} />}
            isPercent={false}
            offsetTop={0}
            step={50}
          />
          <BottomBar className="BottomBar" />
        </>
      )}
    </div>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <AppChrome>
          <Router />
        </AppChrome>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
